import { getCookie } from "./cookies";

export const getCsrfToken = (): string | null => getCookie("qb_csrf") ?? null;
